enum ExternalConnectionType {
    Axxerion,
    BeSense,
    Exchange
}

export default ExternalConnectionType;